import { useLayoutEffect } from 'react';

/**
 * Usage:
 * usePreventScroll(<boolean-condition>);
 **/
function usePushPageDown(enabled: boolean): void {
  const safeDocument: Document = document;

  useLayoutEffect(() => {
    const html = safeDocument?.documentElement;
    const body = safeDocument?.body;

    if (safeDocument == undefined || !html || !body) {
      return;
    }

    if (enabled) {
      body.style.setProperty('padding-top', '3.25rem');
      body.style.setProperty('transition', 'padding-top 350ms');
      /* [1] */
    }

    return () => {
      body.style.removeProperty('padding-top');
    };
  }, [safeDocument, enabled]);
}

export default usePushPageDown;
